import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CodeConverter } from 'server/entity/code-converter';
import { h } from '@fullcalendar/core/preact';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'laas-forwarder-edit',
  templateUrl: './forwarder-edit.component.html',
  styleUrls: ['./forwarder-edit.component.scss']
})
export class ForwarderEditComponent extends SessionBaseComponent implements OnInit {

  forwarderInfo: any;
  bookingNo: string;
  facility: string;
  bookingForwarder: string;
  editForm: FormGroup;
  updateParams: any;
  coOrgIdDesc?: string;
  typCodeOptions: LaasOption[] = [];
  isPaperless: boolean;
  isNoKj3: boolean = false;
  displayHsCodeStrs: string[] = [];
  isShowHsCodeModificationModal: boolean;
  pickupTypeOptions: LaasOption[] = [];
  serviceTypeOptions: LaasOption[] = [];
  packagingTypeOptions: LaasOption[] = [];
  isIbsoFlag: boolean = false;
  countryOptions: any[] = [];
  cityOptions: any[] = [];
  fromCityOptions: any[] = [];
  payTypeOptions: any[] = [];
  distinctSkuDescriptions: any[] = [];

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService
  ) {
    super(injector);
    this.bookingNo = "";
    this.facility = "";
    this.bookingForwarder = "";
    this.updateParams = {};

    this.editForm = this.formBuilder.group({
      recipientPersonName:[''],
      recipientPhoneNumber:[''],
      recipientCity:[''],
      recipientPostalCode:[''],
      recipientStateOrProvinceCode:[''],
      currency:[''],
      payType:[''],
      billingAccountId:[''],
      dutyAndTaxPayerPayType: [''],
      deliveryOrder:[[]],
      description:[''],
      customsValue:[''],
      shipperPersonName:[''],
      dutyAndTaxPayerAccountId: '',
      toTypeCode: '',
      toTypeNumber: '',
      fromTypeCode: '',
      fromTypeNumber: '',
      pltFlag: '',
      isNoKj3: '',
      pickupType: '',
      serviceType: '',
      packagingType: '',
      customerReference: '',
      forwarderInvoices: this.formBuilder.array([]),
      isIbsoFlag: '',
      brokerCompanyName: '',
      brokerContactName: '',
      brokerCountryTerritory: '',
      brokerAddressLine1: '',
      brokerAddressLine2: '',
      brokerCity: '',
      brokerPostalCode: '',
      brokerFirstPhone: '',
      brokerSecondPhone: '',
      brokerFax: '',
      brokerEmail: '',
      brokerExpressAccount: '',
      brokerBankAccount: '',
      brokerTradeNumber: '',
      brokerVatCustomsEin: '',
      brokerStateOrProvinceCode: '',
    });

    this.isPaperless = false;
    this.isShowHsCodeModificationModal = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.facility = this.routeStateService.getCurrent().data.facility;
    this.bookingNo = this.routeStateService.getCurrent().data.bookingNo;
    this.bookingForwarder = this.routeStateService.getCurrent().data.bookingForwarder;


    this.bookingService.getForwarderInfo(this.facility, this.bookingNo).subscribe({
      next: result => {
        if (!result) { return; }
        
        this.forwarderInfo = result;
        //UI
        this.updateParams.recipientPersonName = this.forwarderInfo.recipientPersonName;
        this.updateParams.recipientPhoneNumber = this.forwarderInfo.recipientPhoneNumber;
        this.updateParams.recipientCity = this.forwarderInfo.recipientCity;
        this.updateParams.recipientPostalCode = this.forwarderInfo.recipientPostalCode;
        this.updateParams.recipientStateOrProvinceCode = this.forwarderInfo?.recipientStateOrProvinceCode;
        this.updateParams.currency = this.forwarderInfo.currency;
        this.updateParams.payType = this.forwarderInfo.payType;
        this.updateParams.billingAccountId = this.forwarderInfo.billingAccountId;
        this.updateParams.dutyAndTaxPayerPayType = this.forwarderInfo.dutyAndTaxPayerPayType;
        this.updateParams.description = this.forwarderInfo.description;
        this.updateParams.customsValue = this.forwarderInfo.customsValue;
        this.updateParams.totalGrosswgt = this.forwarderInfo.totalGrosswgt;
        this.updateParams.totalCaseCnt = this.forwarderInfo.totalCaseCnt;
        this.updateParams.shipperPersonName = this.forwarderInfo.shipperPersonName;
        this.updateParams.dutyAndTaxPayerAccountId = this.forwarderInfo.dutyAndTaxPayerAccountId;
        this.updateParams.toTypeCode = this.forwarderInfo.toTypeCode;
        this.updateParams.toTypeNumber = this.forwarderInfo.toTypeNumber;
        this.updateParams.fromTypeCode = this.forwarderInfo.fromTypeCode;
        this.updateParams.fromTypeNumber = this.forwarderInfo.fromTypeNumber;
        this.updateParams.pickupType = this.forwarderInfo.pickupType;
        this.updateParams.serviceType = this.forwarderInfo.serviceType;
        this.updateParams.packagingType = this.forwarderInfo.packagingType;
        this.updateParams.customerReference = this.forwarderInfo.customerReference;

        //fixed
        this.updateParams.facility = this.facility;
        this.updateParams.bookingNo = this.bookingNo;
        this.updateParams.bookingForwarder = this.bookingForwarder;
        this.updateParams.shipperAccountId = this.forwarderInfo.shipperAccountId;
        this.updateParams.recipientCountryCode = this.forwarderInfo.recipientCountryCode;
        this.updateParams.shipTerm = this.forwarderInfo.shipTerm;
        this.updateParams.coOrgId = this.forwarderInfo.coOrgId;
        this.updateParams.pltFlag = (isNullOrEmpty(this.forwarderInfo.pltFlag) || this.forwarderInfo.pltFlag == 'N') ? 'N' : 'Y';
        // isNoKj3 後端存字串("NO KJ3/" 或 "")，轉為 boolean 供 checkbox 顯示
        this.isNoKj3 = !isNullOrEmpty(this.forwarderInfo.isNoKj3);
        this.updateParams.isNoKj3 = this.isNoKj3;
        // const forwarderInvoices = (this.forwarderInfo?.forwarderInvoices || []).map((x: any) => ({ ...x, originalSkuDescription: x.skuDescription }));
        // this.updateParams.forwarderInvoices = forwarderInvoices;
        // NO KJ3/ 由 isNoKj3 欄位另存，description 不應包含它。
        // 舊格式：bare prefix "NO KJ3/LINEAR IC"（先剝前綴）；buggy 格式："NO KJ3/[,]LED"（filter token）。
        let rawDesc = this.forwarderInfo.description || '';
        if (rawDesc.startsWith("NO KJ3/")) {
          rawDesc = rawDesc.substring("NO KJ3/".length);
        }
        const rawParts = rawDesc.split("[,]").filter((s: string) => s.trim() !== "NO KJ3/");
        this.distinctSkuDescriptions = rawParts.map((x: any) => ({
          skuDescription: x.trim(),
          originalSkuDescription: x.trim()
        }));
        if (this.distinctSkuDescriptions.length < 4) {
          const emptySkuDescription = {
            originalSkuDescription: '',
            skuDescription: ''
          };
          for (let i = this.distinctSkuDescriptions.length; i < 4; i++) {
            this.distinctSkuDescriptions.push(emptySkuDescription);
          }
        }
        this.updateParams.forwarderInvoices = this.distinctSkuDescriptions;
        const builder = this.distinctSkuDescriptions.map((e: any) => {
          return this.formBuilder.group(e);
        });
        builder.forEach((x: any) => {
          (this.editForm.controls.forwarderInvoices as FormArray).push(x);
        });
        this.isPaperless = this.updateParams.pltFlag == 'Y' ? true : false;
        this.updateParams.isIbsoFlag = this.forwarderInfo?.isIbsoFlag;
        this.updateParams.brokerCompanyName = this.forwarderInfo?.brokerCompanyName;
        this.updateParams.brokerContactName = this.forwarderInfo?.brokerContactName;
        this.updateParams.brokerCountryTerritory = this.forwarderInfo?.brokerCountryTerritory;
        this.updateParams.brokerAddressLine1 = this.forwarderInfo?.brokerAddressLine1;
        this.updateParams.brokerAddressLine2 = this.forwarderInfo?.brokerAddressLine2;
        this.updateParams.brokerCity = this.forwarderInfo?.brokerCity;
        this.updateParams.brokerPostalCode = this.forwarderInfo?.brokerPostalCode;
        this.updateParams.brokerFirstPhone = this.forwarderInfo?.brokerFirstPhone;
        this.updateParams.brokerSecondPhone = this.forwarderInfo?.brokerSecondPhone;
        this.updateParams.brokerFax = this.forwarderInfo?.brokerFax;
        this.updateParams.brokerEmail = this.forwarderInfo?.brokerEmail;
        this.updateParams.brokerExpressAccount = this.forwarderInfo?.brokerExpressAccount;
        this.updateParams.brokerBankAccount = this.forwarderInfo?.brokerBankAccount;
        this.updateParams.brokerTradeNumber = this.forwarderInfo?.brokerTradeNumber;
        this.updateParams.brokerVatCustomsEin = this.forwarderInfo?.brokerVatCustomsEin;
        this.updateParams.brokerStateOrProvinceCode = this.forwarderInfo?.brokerStateOrProvinceCode;

        this.dropdownOptionService.getAllCityOptions()
        .subscribe({
          next: (options: any[]) => {
            this.cityOptions = options.filter(x => x.country == this.updateParams.brokerCountryTerritory).map(x => ({ label: x.name, value: x.seqNo.toString() }));
          }
        });

        if(!isNullOrEmpty(this.forwarderInfo?.coOrgId)){
          this.facilityService.getLetterOrgOptions('ALL', '').subscribe({
            next: (options: any[]) => {
              if(options != null && options.length > 0){
                let opt = options.filter((option:any) => option.legalEntityOUCode == this.forwarderInfo?.coOrgId);
                if(opt != null && opt.length > 0){
                  this.coOrgIdDesc = opt[0].legalEntityOUCode + '-' + opt[0].legalEntityOUName;
                }
              }
            }
          });
        }
        this.initDeliveryOrder(result);
        this.getForwarderInvoiceSkuDescriptionOptions(this.distinctSkuDescriptions);
        if (this.isNoKj3) {
          this.displayHsCodeStrs = ["NO KJ3/", ...this.displayHsCodeStrs];
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });

    combineLatest([
      this.translateService.get("Common.DropDown.Select"),
      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "ForwarderTypeCode")
    ]).subscribe({
      next: ([selectLabel, options]: [string, CodeConverter[]]) => {
        this.typCodeOptions = options.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}));
        this.typCodeOptions.unshift({
          label: selectLabel,
          value: ''
        });
      }
    });

    combineLatest([
      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FedExPickupType"),
      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FedExServiceType"),
      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FedExPackagingType")
    ]).subscribe({
      next: ([pickupOptions, serviceOptions, packagingOptions]: [CodeConverter[], CodeConverter[], CodeConverter[]]) => {
        this.pickupTypeOptions = pickupOptions.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}));
        this.serviceTypeOptions = serviceOptions.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}));
        this.packagingTypeOptions = packagingOptions.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}));
      }
    });

    this.dropdownOptionService.getCountryOptions()
    .subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
      }
    });

    this.dropdownOptionService.getPayTypeOptions()
    .subscribe({
      next: (options: any[]) => {
        this.payTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });
  }

  saveBtn(event: any): void{
    this.updateParams.userId = this.userProfile.loginAccount;
    this.updateParams.pltFlag = this.isPaperless ? 'Y' : 'N';
    this.updateParams.description = this.convertForwarderInvoiceSkuDescriptionToForwarderInfoDescription();


    if (isNullOrEmpty(this.updateParams.toTypeCode)) {
      this.updateParams.toTypeCode = null;
    }
    if (isNullOrEmpty(this.updateParams.fromTypeCode)) {
      this.updateParams.fromTypeCode = null;
    }
    if (isNullOrEmpty(this.updateParams.pickupType)) {
      this.updateParams.pickupType = null;
    }
    if (isNullOrEmpty(this.updateParams.serviceType)) {
      this.updateParams.serviceType = null;
    }
    if (isNullOrEmpty(this.updateParams.packagingType)) {
      this.updateParams.packagingType = null;
    }

    // saveDHLInfo 改寫
    this.bookingService.updateForwarderInfo(this.updateParams).subscribe({
      next: result => {
        this.toastService.info("更新成功")
        this.routeStateService.navigateTo("/TransportOperation/BookingSearch", {bookingNoList:[this.bookingNo], errMsgs:[]})
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  closeWindow(event: any): void{
    window.close();
  }


  /* 打開「內容物描述」彈窗 */
  toogleBtnClick(event: any): void {
    this.editForm.controls['forwarderInvoices'].setValue(this.distinctSkuDescriptions);
    this.isShowHsCodeModificationModal = true;
  }

  closeDialog(event: any): void {
    this.isShowHsCodeModificationModal = false;
  }

  initDeliveryOrder(result: any): void {
    const options = result.forwarderInfoDetails ?? [];

    this.updateParams.deliveryOrder = options.map((x: { doNo: string }) => x.doNo);
  }

  getForwarderInvoiceSkuDescriptionOptions(result: any): void {
    const options = result;
    this.displayHsCodeStrs = options.map((x: { skuDescription: any; }) => `${x.skuDescription}`).filter(Boolean);
  }

  convertForwarderInvoiceSkuDescriptionToForwarderInfoDescription(): string {
    // "NO KJ3/" 僅供顯示，由 isNoKj3 欄位另存，不寫入 description
    const forwarderInfoDescription = this.displayHsCodeStrs.filter(s => s !== "NO KJ3/").join("[,]");
    return forwarderInfoDescription;
  }

  onIsNoKj3Change($event: any): void {
    this.isNoKj3 = $event;
    this.updateParams.isNoKj3 = $event;
    if ($event) {
      this.displayHsCodeStrs = [
        "NO KJ3/",
        ...this.displayHsCodeStrs.filter(strObj => strObj !== "NO KJ3/")
      ];
    } else {
      this.displayHsCodeStrs = this.displayHsCodeStrs.filter(strObj => strObj !== "NO KJ3/");
    }
  }

  refreshDescription(): void {
    this.updateParams.description = this.convertForwarderInvoiceSkuDescriptionToForwarderInfoDescription();
  }

  /* 「內容物描述」彈窗的確認按鈕 */
  confirmBtnClick($event: MouseEvent) {
    this.distinctSkuDescriptions = this.editForm.controls.forwarderInvoices.value;
    
    this.getForwarderInvoiceSkuDescriptionOptions(this.distinctSkuDescriptions);
    this.closeDialog($event);
  }

  cleanAllDescription($event: MouseEvent): void {
    const clearData = this.distinctSkuDescriptions.map((x: any) => ({
      skuDescription: '',
      originalSkuDescription: x.originalSkuDescription
    }));
    this.editForm.controls['forwarderInvoices'].setValue(clearData);
  }

  clearReference($event: MouseEvent): void {
    this.updateParams.customerReference = '';
  }

  changeBrokerCityOptions(): void {
    this.updateParams.brokerCity = "";

    this.dropdownOptionService.getAllCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.cityOptions = options.filter(x => x.country == this.updateParams.brokerCountryTerritory).map(x => ({ label: x.name, value: x.seqNo.toString() }));
      }
    });
  }
}
